import type { FunctionComponent } from 'react';
import ConsentLegalDisclaimer from '../../shared/agent-consent/LegalDisclaimer/LegalDisclaimer';
import { a2aLegalDisclaimerMessages } from './messages';

const LegalDisclaimer: FunctionComponent = () => (
  <ConsentLegalDisclaimer
    messages={{
      agreementHeader: a2aLegalDisclaimerMessages.agreementHeader,
      agreementLinks: a2aLegalDisclaimerMessages.agreementLinks,
      privacyPolicy: a2aLegalDisclaimerMessages.privacyPolicy,
      termsOfUse: a2aLegalDisclaimerMessages.termsOfUse,
    }}
  />
);

export default LegalDisclaimer;
